import { Injectable } from '@angular/core';
import { NavModel } from '@libs/shared/models';
import { NavStateService } from '../nav-state/nav-state.service';

@Injectable({
  providedIn: 'root',
})
export class NavManagerService {
  private readonly navMap: Record<string, NavStateService> = {};

  public getService(model: NavModel): NavStateService {
    if (!model.name) {
      return new NavStateService(model);
    }

    if (!this.navMap[model.name]) {
      this.navMap[model.name] = new NavStateService(model);
    }

    return this.navMap[model.name];
  }
}
